import { useEffect, useState } from "react";

const SPLASH_MS = 4500;
const SPLASH_KEY = "ethara_splash_shown";

export function useLoginSplash() {
  const [show, setShow] = useState(false);

  const trigger = () => {
    sessionStorage.setItem(SPLASH_KEY, "1");
    setShow(true);
  };

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => setShow(false), SPLASH_MS);
    return () => clearTimeout(t);
  }, [show]);

  return { show, trigger, dismiss: () => setShow(false) };
}

export function LoginSplash({ open, onDismiss }) {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[100] bg-[#2a1a0e] flex items-center justify-center animate-in fade-in duration-500"
      data-testid="login-splash"
      onClick={onDismiss}
    >
      <img
        src="/ecosystem-splash.jpeg"
        alt="Every ecosystem starts with people"
        className="max-w-full max-h-full w-auto h-auto object-contain select-none pointer-events-none"
      />
      <button
        onClick={onDismiss}
        className="absolute top-4 right-4 text-white/70 hover:text-white text-xs uppercase tracking-wider bg-black/30 hover:bg-black/50 rounded-full px-3 py-1.5 backdrop-blur-sm"
        data-testid="splash-skip-btn"
      >
        Skip
      </button>
    </div>
  );
}

export function shouldShowSplash() {
  return !sessionStorage.getItem(SPLASH_KEY);
}
